import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import { POSITIONS } from '@fiverr-private/fit/src/components/Popover/constants';
import { Icon, Tooltip } from '@fiverr-private/fit';
import { s_info_circle } from '@fiverr-private/fit/icons';
import tracker from '../../../../service/tracker';
import './index.scss';

const PromotedAdsInfoIcon = () => (
    <Tooltip className="promoted-ads-tooltip promoted-ads-tooltip-content promoted-ads-tooltip-z-index"
        position={POSITIONS.TOP}
        onOpen={() => tracker.promotedAdsTooltipView()}
        content={<p><I18n k="search_perseus.number_of_results.results_with_ads_tooltip"/></p>}>
        <Icon className="promoted-ads-info-icon">{s_info_circle}</Icon>
    </Tooltip>
);

export default PromotedAdsInfoIcon;
